<template>
  <div>
    <demandeEntete
      :demandeur="demandeur"
      :typeDemande="typeDemande"
      :codeTypeDemande="codeTypeDemande"
      :dateCreation="dateCreation"
      :commentaire="commentaire"
      :complements="complements"
      :motifRefus="motifRefus"
    />

    <viewInstance
      ref="view"
      :enums="enums"
      :form="form"
      :control="control"
      :analyseDiff="analyseDiff"
      @annulerSuppression="annulerSuppression($event)"
    >
    </viewInstance>

    <entiteModificationModal />

    <demandeAction />
  </div>
</template>

<script>
import ViewInstance from '@/view/instance/ViewInstance';
import DemandeEntete from '@/components/workflow/DemandeEntete';
import DemandeAction from '@/components/workflow/DemandeAction';
import EditeurDemande from '@/plugins/mixins/EditeurDemande';
import { routeEnter } from '@/utils/entite';
import toasted from '@/utils/toasted';

export default {
  components: {
    viewInstance: ViewInstance,
    demandeEntete: DemandeEntete,
    demandeAction: DemandeAction,
  },
  mixins: [EditeurDemande],

  beforeRouteEnter: routeEnter(withId => {
    withId(
      id => `workflow/demande/${id}`,
      (vm, body) => vm.initForm(body),
    );
  }),
  data() {
    return {
      // Configuration de l'IHM
      control: {
        readonly: true,
        enDemandeModification: false,
      },

      // Les enums
      enums: {
        typesInstance: [],
        typesParticipant: [],
      },
      commentaire: null,
      motifRefus: null,

      // Le formulaire
      form: {
        id: null,
        nom: null,
        description: null,
        urlSharepoint: null,
        typeInstance: null,
        referent: {
          id: null,
        },
        gestionnaires: [],
        participants: [],
        size: null,
        dateDebut: null,
        dateFin: null,
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
      },
    };
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  watch: {},
  methods: {
    // Gestion de l'initialisation du formulaire
    initForm(data) {
      this.initEditeurDemande(data);
      //injection du droit d'edition
      this.control.edition = 'AUCUN';

      const loaded = data.objet;
      this.form.dateCreation = loaded.dateCreation || null;
      this.form.chargeCreation = loaded.chargeCreation || null;
      this.form.dateModification = loaded.dateModification || null;
      this.form.demandeurCreation = loaded.demandeurCreation || null;
      this.form.chargeModification = loaded.chargeModification || null;

      this.form.id = loaded.id || null;
      this.form.nom = loaded.nom || null;
      this.form.urlSharepoint = loaded.urlSharepoint || null;
      this.form.description = loaded.description || null;

      this.form.typeInstance = loaded.typeInstance || null;
      this.form.referent = loaded.referent || { id: null };
      this.form.size = loaded.size || null;
      this.form.fax = loaded.fax || null;
      this.form.dateDebut = loaded.dateDebut || null;
      this.form.dateFin = loaded.dateFin || null;

      // Collections
      this.form.gestionnaires = loaded.gestionnaires || [];
      this.form.participants = loaded.participants || [];

      if (data.enums) {
        this.initEnums(data.enums);
      }

      this.__initEdition();
    },

    // Appelée après chargement des listes d'enums depuis le Back
    initEnums(body) {
      const enums = this.enums;
      enums.typesInstance = body.typesInstance;
      enums.typesParticipant = body.typesParticipant;
    },

    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },

    validerDemande() {
      const id = this.idDemande;

      var data = null;
      var url = null;
      if ('modification' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        url = `workflow/demande/modification/${id}/instance/valider`;
        // filtre en supprimant tous les champs supprimés
        data = this.form;

        data.participants = data.participants.filter(
          this.creationFiltreSupprimes('participants', true),
        );
        data.gestionnaires = data.gestionnaires.filter(
          this.creationFiltreSupprimes('gestionnaires'),
        );
      } else if ('suppression' === this.codeTypeDemande) {
        url = `workflow/demande/suppression/${id}/instance/valider`;
      } else if ('creation' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        url = `workflow/demande/creation/${id}/instance/valider`;
        data = this.form;
      }

      this.control.validerDemande = true;
      this.$api(url)
        .post(data)
        .then(() => {
          toasted.info('demande.status.valide');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .catch(errors => {
          this.control.dialogValider = false;
          this.errorsHandler(errors);
        })
        .finally(() => (this.control.validerDemande = false));
    },
  },
};
</script>
